module.exports = __webpack_public_path__ + "media/images/spc_limits_explained-0b8da677.png";